import React from 'react';
import styles from './GroupingPage.scss';
import { shallowEqual } from 'react-redux';
import classNames from 'classnames';
import { isEmptyObject, isMobileOrTabletWindow } from '~/utils/utils';
import VideoBackground from '~/components/VideoBackground/VideoBackground';
import { useAvailableSound } from '~/hooks/useAvailableSound';
import isDisabledAnimation from '~/hooks/isDisabledAnimation';
import { RootState, useAppSelector } from '~/Store';
import { CategoryThemes } from '~/types/category';

const stateSelector = (state: RootState) => {
    return {
        currentPage: state.app.currentPage,
        categories: state.app.categories,
        categoriesAnimationStatuses: state.app.categoriesAnimationStatuses,
        isTrusted: state.app.isTrusted,
    };
};

const GroupingPageBackground = () => {
    const state = useAppSelector(stateSelector, shallowEqual);
    const { isBundlePage } = state.currentPage || {};
    const category = state.categories[state.currentPage?.name];
    const _isDisabledAnimation = isDisabledAnimation(CategoryThemes.GROUPING_PAGE_THEME);
    const isAvailableSoundEffect = useAvailableSound(category, null);

    if (isBundlePage) {
        if (isMobileOrTabletWindow) {
            return (
                <div className={styles.backgroundWrapper}>
                    <div className={styles.background}></div>
                </div>
            );
        }

        return null;
    }

    let muted = !isAvailableSoundEffect;
    if (!state.isTrusted) {
        muted = true;
    }

    const style: React.CSSProperties = {};
    if (category.backgroundColor) {
        style.backgroundColor = category.backgroundColor;
    }

    const backgroundStyle = {
        '--common-background': `url(${category.background})`,
    } as React.CSSProperties;

    return (
        <div className={classNames(styles.backgroundWrapper)} style={style}>
            {isEmptyObject(category.videoBackground) || isMobileOrTabletWindow || _isDisabledAnimation ? (
                <div className={styles.background} style={backgroundStyle}>
                    <div className={styles.videoBackgroundMask}></div>
                </div>
            ) : (
                <VideoBackground
                    key={`grouping_background_${category.name}`}
                    poster={category.background}
                    video={category.videoBackground}
                    muted={muted}
                    className={styles.videoBackgroundWrapper}
                    volume={0.5}
                    posterClassName={styles.background}
                    videoClassName={styles.videoBackground}
                >
                    <div className={styles.videoBackgroundMask}></div>
                </VideoBackground>
            )}
        </div>
    );
};

export default GroupingPageBackground;
